<template>
    <div class="error_container">
        <div class="logo_box">
            <img src="data:image/png;base64,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"
                alt="kicc_logo" />
        </div>
        <h1>404</h1>
        <p>Page Not Found</p>
        <a href="/" class="">메인 페이지</a>
        <br />
        <div class="bottom_layer">
            <p>
                KICC 인터넷PC현금영수증 사이트 접속을 원하시는 경우, 아래 버튼으로
                접속하시기 바랍니다.
            </p>
            <a href="https://keep.kicc.co.kr/pc/login/LoginMainAction.do" target="_black">[KICC 인터넷 PC 현금영수증 바로가기]</a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'NotFoundPage',
};
</script>

<style scoped lang="scss">
.error_container {
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.error_container * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family: Pretendard, sans-serif;
    letter-spacing: -0.025em;
    color: #111;
    word-break: keep-all;
}

.error_container .logo_box {
    width: 100px;
    margin-bottom: 20px;
}

.error_container h1 {
    color: #333;
    line-height: 1;
    text-align: center;
    font-size: 96px;
    margin-bottom: 20px;
}

.error_container>p {
    font-size: 20px;
    margin-bottom: 40px;
}

.error_container>a {
    height: 40px;
    padding: 0 20px;
    background: #e61c39;
    color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    text-decoration: none;
}

.error_container>a:hover {
    background: #000;
}

.error_container img {
    width: 100%;
    max-width: 100%;
}

.bottom_layer {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 2vmin;
    gap: 1vmin;
}

.bottom_layer p {
    color: #333;
    text-align: center;
}

.bottom_layer a {
    font-weight: 700;
    text-decoration: none;
    color: rgb(241, 120, 60);
}

@media screen and (max-width: 768px) {
    .error_container .logo_box {
        width: 20vmin;
        margin-bottom: 5vmin;
    }

    .error_container h1 {
        font-size: 20vmin;
        margin-bottom: 5vmin;
    }

    .error_container>p {
        font-size: 5vmin;
    }

    .bottom_layer p {
        font-size: 4.5vmin;
    }

    .bottom_layer a {
        margin-top: 4vmin;
        font-size: 4.5vmin;
    }

    .error_container>a {
        height: auto;
        font-size: 4vmin;
        padding: 3vmin 5vmin;
    }
}
</style>
